// language=GraphQL
export const ALL_TRAVELS_QUERY = `query Query($withRatioCatalogBundle: Boolean = false, $withDates: Boolean = false, $withDatesAvailabilityStatus: Boolean = false, $withDatesAvailabilityStatusTenantSettings: Boolean = false, $withDatesExtensionBaseDate: Boolean = false, $withDatesExtensionBaseDateAvailabilityStatus: Boolean = false, $withDatesExtensionBaseDateExtensionBaseDate: Boolean = false, $withDatesExtensionBaseDateExtension: Boolean = false, $withDatesExtensionBaseDatePackageSettings: Boolean = false, $withDatesExtensionBaseDateExtensions: Boolean = false, $withDatesExtension: Boolean = false, $withDatesExtensionTravelExtension: Boolean = false, $withDatesExtensionAccommodationMapItems: Boolean = false, $withDatesPackageSettings: Boolean = false, $withDatesExtensions: Boolean = false, $withDatesExtensionsTravelExtension: Boolean = false, $withDatesExtensionsAccommodationMapItems: Boolean = false, $withAccommodations: Boolean = false, $withAccommodationsCapacitySettings: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationsAddons: Boolean = false, $withAccommodationsAddonsCalculationSettings: Boolean = false, $withAccommodationsAddonsMandatorySettings: Boolean = false, $withExtensionAccommodations: Boolean = false, $withFamilyPackages: Boolean = false, $withFamilyPackagesAccommodation: Boolean = false, $withFamilyPackagesAccommodationCapacitySettings: Boolean = false, $withFamilyPackagesAccommodationAddons: Boolean = false, $withFamilyPackagesCapacitySettings: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackagesAddons: Boolean = false, $withFamilyPackagesAddonsCalculationSettings: Boolean = false, $withFamilyPackagesAddonsMandatorySettings: Boolean = false, $withPersonalAddons: Boolean = false, $withPersonalAddonsAllowedAgeGroups: Boolean = false, $withPersonalAddonsCalculationSettings: Boolean = false, $withPersonalAddonsMandatorySettings: Boolean = false, $withPersonalAddonsMandatorySettingsRules: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withBookingAddons: Boolean = false, $withBookingAddonsCalculationSettings: Boolean = false, $withBookingAddonsMandatorySettings: Boolean = false, $withBookingAddonsMandatorySettingsRules: Boolean = false, $withCollectiveAddons: Boolean = false, $withCollectiveAddonsAgeGroupServices: Boolean = false, $withCollectiveAddonsAgeGroupServicesAgeGroup: Boolean = false, $withCollectiveAddonsCalculationSettings: Boolean = false, $withCollectiveAddonsMandatorySettings: Boolean = false, $withCollectiveAddonsMandatorySettingsRules: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPersonalDiscounts: Boolean = false, $withPersonalDiscountsMandatorySettings: Boolean = false, $withPersonalDiscountsMandatorySettingsRules: Boolean = false) {
  travels: ratioTravels {
    id
    ratioCatalogBundle @include(if: $withRatioCatalogBundle) {
      id
      catalogCode
      travelCode
      json
    }
    catalogCode
    travelCode
    destination
    name
    transportType
    transportTypeLabel
    dates @include(if: $withDates) {
      id
      dateNo
      startDate
      endDate
      availabilityStatus @include(if: $withDatesAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withDatesAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      includesExtension
      extensionBaseDate @include(if: $withDatesExtensionBaseDate) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withDatesExtensionBaseDateAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        includesExtension
        extensionBaseDate @include(if: $withDatesExtensionBaseDateExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          includesExtension
          json
        }
        extension @include(if: $withDatesExtensionBaseDateExtension) {
          id
          label
          info
        }
        packageSettings @include(if: $withDatesExtensionBaseDatePackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withDatesExtensionBaseDateExtensions) {
          id
          label
          info
        }
      }
      extension @include(if: $withDatesExtension) {
        id
        label
        info
        travelExtension @include(if: $withDatesExtensionTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withDatesExtensionAccommodationMapItems) {
          id
        }
      }
      packageSettings @include(if: $withDatesPackageSettings) {
        id
        ratioPackageNo
        price
        availabilityStatus
      }
      json
      extensions @include(if: $withDatesExtensions) {
        id
        label
        info
        travelExtension @include(if: $withDatesExtensionsTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withDatesExtensionsAccommodationMapItems) {
          id
        }
      }
    }
    accommodations @include(if: $withAccommodations) {
      id
      ratioPackageNo
      name
      label
      info
      isFamilyPackageAccommodation
      isBabyPackage
      capacitySettings @include(if: $withAccommodationsCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withAccommodationsAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAccommodationsAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAccommodationsAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
    }
    extensionAccommodations @include(if: $withExtensionAccommodations) {
      id
      ratioPackageNo
      name
      label
      info
      extensionAccommodationServiceNo
    }
    familyPackages @include(if: $withFamilyPackages) {
      id
      ratioServiceNo
      accommodation @include(if: $withFamilyPackagesAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withFamilyPackagesAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withFamilyPackagesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      name
      label
      info
      capacitySettings @include(if: $withFamilyPackagesCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withFamilyPackagesAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withFamilyPackagesAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withFamilyPackagesAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
    }
    personalAddons @include(if: $withPersonalAddons) {
      id
      ratioServiceNo
      name
      label
      info
      allowedAgeGroups @include(if: $withPersonalAddonsAllowedAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      calculationSettings @include(if: $withPersonalAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withPersonalAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withPersonalAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
      }
    }
    accommodationAddons @include(if: $withAccommodationAddons) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
      }
    }
    bookingAddons @include(if: $withBookingAddons) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withBookingAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withBookingAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withBookingAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
      }
    }
    collectiveAddons @include(if: $withCollectiveAddons) {
      id
      label
      info
      ageGroupServices @include(if: $withCollectiveAddonsAgeGroupServices) {
        id
        ageGroup @include(if: $withCollectiveAddonsAgeGroupServicesAgeGroup) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        ratioServiceNo
      }
      calculationSettings @include(if: $withCollectiveAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withCollectiveAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withCollectiveAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
      }
    }
    extensions @include(if: $withExtensions) {
      id
      label
      info
      travelExtension @include(if: $withExtensionsTravelExtension) {
        id
        duration
        name
        description
        highlights @include(if: $withExtensionsTravelExtensionHighlights) {
          id
          text
        }
        image @include(if: $withExtensionsTravelExtensionImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {
        id
        baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
      }
    }
    personalDiscounts @include(if: $withPersonalDiscounts) {
      id
      ratioServiceNo
      name
      label
      info
      mandatorySettings @include(if: $withPersonalDiscountsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withPersonalDiscountsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
      }
    }
    importDateTime
    importStatus
  }
}`

// language=GraphQL
export const SINGLE_TRAVEL_QUERY = `query Query($id: ID!, $withRatioCatalogBundle: Boolean = false, $withDates: Boolean = false, $withDatesAvailabilityStatus: Boolean = false, $withDatesAvailabilityStatusTenantSettings: Boolean = false, $withDatesExtensionBaseDate: Boolean = false, $withDatesExtensionBaseDateAvailabilityStatus: Boolean = false, $withDatesExtensionBaseDateExtensionBaseDate: Boolean = false, $withDatesExtensionBaseDateExtension: Boolean = false, $withDatesExtensionBaseDatePackageSettings: Boolean = false, $withDatesExtensionBaseDateExtensions: Boolean = false, $withDatesExtension: Boolean = false, $withDatesExtensionTravelExtension: Boolean = false, $withDatesExtensionAccommodationMapItems: Boolean = false, $withDatesPackageSettings: Boolean = false, $withDatesExtensions: Boolean = false, $withDatesExtensionsTravelExtension: Boolean = false, $withDatesExtensionsAccommodationMapItems: Boolean = false, $withAccommodations: Boolean = false, $withAccommodationsCapacitySettings: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationsAddons: Boolean = false, $withAccommodationsAddonsCalculationSettings: Boolean = false, $withAccommodationsAddonsMandatorySettings: Boolean = false, $withExtensionAccommodations: Boolean = false, $withFamilyPackages: Boolean = false, $withFamilyPackagesAccommodation: Boolean = false, $withFamilyPackagesAccommodationCapacitySettings: Boolean = false, $withFamilyPackagesAccommodationAddons: Boolean = false, $withFamilyPackagesCapacitySettings: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackagesAddons: Boolean = false, $withFamilyPackagesAddonsCalculationSettings: Boolean = false, $withFamilyPackagesAddonsMandatorySettings: Boolean = false, $withPersonalAddons: Boolean = false, $withPersonalAddonsAllowedAgeGroups: Boolean = false, $withPersonalAddonsCalculationSettings: Boolean = false, $withPersonalAddonsMandatorySettings: Boolean = false, $withPersonalAddonsMandatorySettingsRules: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withBookingAddons: Boolean = false, $withBookingAddonsCalculationSettings: Boolean = false, $withBookingAddonsMandatorySettings: Boolean = false, $withBookingAddonsMandatorySettingsRules: Boolean = false, $withCollectiveAddons: Boolean = false, $withCollectiveAddonsAgeGroupServices: Boolean = false, $withCollectiveAddonsAgeGroupServicesAgeGroup: Boolean = false, $withCollectiveAddonsCalculationSettings: Boolean = false, $withCollectiveAddonsMandatorySettings: Boolean = false, $withCollectiveAddonsMandatorySettingsRules: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPersonalDiscounts: Boolean = false, $withPersonalDiscountsMandatorySettings: Boolean = false, $withPersonalDiscountsMandatorySettingsRules: Boolean = false) {
  travel: ratioTravel(id: $id) {
    id
    ratioCatalogBundle @include(if: $withRatioCatalogBundle) {
      id
      catalogCode
      travelCode
      json
    }
    catalogCode
    travelCode
    destination
    name
    transportType
    transportTypeLabel
    dates @include(if: $withDates) {
      id
      dateNo
      startDate
      endDate
      availabilityStatus @include(if: $withDatesAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withDatesAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      includesExtension
      extensionBaseDate @include(if: $withDatesExtensionBaseDate) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withDatesExtensionBaseDateAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        includesExtension
        extensionBaseDate @include(if: $withDatesExtensionBaseDateExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          includesExtension
          json
        }
        extension @include(if: $withDatesExtensionBaseDateExtension) {
          id
          label
          info
        }
        packageSettings @include(if: $withDatesExtensionBaseDatePackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withDatesExtensionBaseDateExtensions) {
          id
          label
          info
        }
      }
      extension @include(if: $withDatesExtension) {
        id
        label
        info
        travelExtension @include(if: $withDatesExtensionTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withDatesExtensionAccommodationMapItems) {
          id
        }
      }
      packageSettings @include(if: $withDatesPackageSettings) {
        id
        ratioPackageNo
        price
        availabilityStatus
      }
      json
      extensions @include(if: $withDatesExtensions) {
        id
        label
        info
        travelExtension @include(if: $withDatesExtensionsTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withDatesExtensionsAccommodationMapItems) {
          id
        }
      }
    }
    accommodations @include(if: $withAccommodations) {
      id
      ratioPackageNo
      name
      label
      info
      isFamilyPackageAccommodation
      isBabyPackage
      capacitySettings @include(if: $withAccommodationsCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withAccommodationsAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAccommodationsAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAccommodationsAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
    }
    extensionAccommodations @include(if: $withExtensionAccommodations) {
      id
      ratioPackageNo
      name
      label
      info
      extensionAccommodationServiceNo
    }
    familyPackages @include(if: $withFamilyPackages) {
      id
      ratioServiceNo
      accommodation @include(if: $withFamilyPackagesAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withFamilyPackagesAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withFamilyPackagesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      name
      label
      info
      capacitySettings @include(if: $withFamilyPackagesCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withFamilyPackagesAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withFamilyPackagesAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withFamilyPackagesAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
    }
    personalAddons @include(if: $withPersonalAddons) {
      id
      ratioServiceNo
      name
      label
      info
      allowedAgeGroups @include(if: $withPersonalAddonsAllowedAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      calculationSettings @include(if: $withPersonalAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withPersonalAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withPersonalAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
      }
    }
    accommodationAddons @include(if: $withAccommodationAddons) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
      }
    }
    bookingAddons @include(if: $withBookingAddons) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withBookingAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withBookingAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withBookingAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
      }
    }
    collectiveAddons @include(if: $withCollectiveAddons) {
      id
      label
      info
      ageGroupServices @include(if: $withCollectiveAddonsAgeGroupServices) {
        id
        ageGroup @include(if: $withCollectiveAddonsAgeGroupServicesAgeGroup) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        ratioServiceNo
      }
      calculationSettings @include(if: $withCollectiveAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withCollectiveAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withCollectiveAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
      }
    }
    extensions @include(if: $withExtensions) {
      id
      label
      info
      travelExtension @include(if: $withExtensionsTravelExtension) {
        id
        duration
        name
        description
        highlights @include(if: $withExtensionsTravelExtensionHighlights) {
          id
          text
        }
        image @include(if: $withExtensionsTravelExtensionImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {
        id
        baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
      }
    }
    personalDiscounts @include(if: $withPersonalDiscounts) {
      id
      ratioServiceNo
      name
      label
      info
      mandatorySettings @include(if: $withPersonalDiscountsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withPersonalDiscountsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
      }
    }
    importDateTime
    importStatus
  }
}`

// language=GraphQL
export const CREATE_TRAVEL_MUTATION = `
  mutation Mutation($input: CreateRatioTravelInput, $withRatioCatalogBundle: Boolean = false, $withDates: Boolean = false, $withDatesAvailabilityStatus: Boolean = false, $withDatesAvailabilityStatusTenantSettings: Boolean = false, $withDatesExtensionBaseDate: Boolean = false, $withDatesExtensionBaseDateAvailabilityStatus: Boolean = false, $withDatesExtensionBaseDateExtensionBaseDate: Boolean = false, $withDatesExtensionBaseDateExtension: Boolean = false, $withDatesExtensionBaseDatePackageSettings: Boolean = false, $withDatesExtensionBaseDateExtensions: Boolean = false, $withDatesExtension: Boolean = false, $withDatesExtensionTravelExtension: Boolean = false, $withDatesExtensionAccommodationMapItems: Boolean = false, $withDatesPackageSettings: Boolean = false, $withDatesExtensions: Boolean = false, $withDatesExtensionsTravelExtension: Boolean = false, $withDatesExtensionsAccommodationMapItems: Boolean = false, $withAccommodations: Boolean = false, $withAccommodationsCapacitySettings: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationsAddons: Boolean = false, $withAccommodationsAddonsCalculationSettings: Boolean = false, $withAccommodationsAddonsMandatorySettings: Boolean = false, $withExtensionAccommodations: Boolean = false, $withFamilyPackages: Boolean = false, $withFamilyPackagesAccommodation: Boolean = false, $withFamilyPackagesAccommodationCapacitySettings: Boolean = false, $withFamilyPackagesAccommodationAddons: Boolean = false, $withFamilyPackagesCapacitySettings: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackagesAddons: Boolean = false, $withFamilyPackagesAddonsCalculationSettings: Boolean = false, $withFamilyPackagesAddonsMandatorySettings: Boolean = false, $withPersonalAddons: Boolean = false, $withPersonalAddonsAllowedAgeGroups: Boolean = false, $withPersonalAddonsCalculationSettings: Boolean = false, $withPersonalAddonsMandatorySettings: Boolean = false, $withPersonalAddonsMandatorySettingsRules: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withBookingAddons: Boolean = false, $withBookingAddonsCalculationSettings: Boolean = false, $withBookingAddonsMandatorySettings: Boolean = false, $withBookingAddonsMandatorySettingsRules: Boolean = false, $withCollectiveAddons: Boolean = false, $withCollectiveAddonsAgeGroupServices: Boolean = false, $withCollectiveAddonsAgeGroupServicesAgeGroup: Boolean = false, $withCollectiveAddonsCalculationSettings: Boolean = false, $withCollectiveAddonsMandatorySettings: Boolean = false, $withCollectiveAddonsMandatorySettingsRules: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPersonalDiscounts: Boolean = false, $withPersonalDiscountsMandatorySettings: Boolean = false, $withPersonalDiscountsMandatorySettingsRules: Boolean = false) {
    travel: createRatioTravel(input: $input) {
      id
      ratioCatalogBundle @include(if: $withRatioCatalogBundle) {
        id
        catalogCode
        travelCode
        json
      }
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      dates @include(if: $withDates) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withDatesAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withDatesAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        includesExtension
        extensionBaseDate @include(if: $withDatesExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          availabilityStatus @include(if: $withDatesExtensionBaseDateAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          includesExtension
          extensionBaseDate @include(if: $withDatesExtensionBaseDateExtensionBaseDate) {
            id
            dateNo
            startDate
            endDate
            includesExtension
            json
          }
          extension @include(if: $withDatesExtensionBaseDateExtension) {
            id
            label
            info
          }
          packageSettings @include(if: $withDatesExtensionBaseDatePackageSettings) {
            id
            ratioPackageNo
            price
            availabilityStatus
          }
          json
          extensions @include(if: $withDatesExtensionBaseDateExtensions) {
            id
            label
            info
          }
        }
        extension @include(if: $withDatesExtension) {
          id
          label
          info
          travelExtension @include(if: $withDatesExtensionTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withDatesExtensionAccommodationMapItems) {
            id
          }
        }
        packageSettings @include(if: $withDatesPackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withDatesExtensions) {
          id
          label
          info
          travelExtension @include(if: $withDatesExtensionsTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withDatesExtensionsAccommodationMapItems) {
            id
          }
        }
      }
      accommodations @include(if: $withAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withAccommodationsCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withAccommodationsAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withAccommodationsAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withAccommodationsAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
      }
      extensionAccommodations @include(if: $withExtensionAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        extensionAccommodationServiceNo
      }
      familyPackages @include(if: $withFamilyPackages) {
        id
        ratioServiceNo
        accommodation @include(if: $withFamilyPackagesAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withFamilyPackagesAccommodationCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withFamilyPackagesAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        name
        label
        info
        capacitySettings @include(if: $withFamilyPackagesCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withFamilyPackagesAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withFamilyPackagesAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withFamilyPackagesAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
      }
      personalAddons @include(if: $withPersonalAddons) {
        id
        ratioServiceNo
        name
        label
        info
        allowedAgeGroups @include(if: $withPersonalAddonsAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        calculationSettings @include(if: $withPersonalAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPersonalAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withPersonalAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
        }
      }
      accommodationAddons @include(if: $withAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
        }
      }
      bookingAddons @include(if: $withBookingAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withBookingAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withBookingAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withBookingAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
        }
      }
      collectiveAddons @include(if: $withCollectiveAddons) {
        id
        label
        info
        ageGroupServices @include(if: $withCollectiveAddonsAgeGroupServices) {
          id
          ageGroup @include(if: $withCollectiveAddonsAgeGroupServicesAgeGroup) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          ratioServiceNo
        }
        calculationSettings @include(if: $withCollectiveAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withCollectiveAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withCollectiveAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
        }
      }
      extensions @include(if: $withExtensions) {
        id
        label
        info
        travelExtension @include(if: $withExtensionsTravelExtension) {
          id
          duration
          name
          description
          highlights @include(if: $withExtensionsTravelExtensionHighlights) {
            id
            text
          }
          image @include(if: $withExtensionsTravelExtensionImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {
          id
          baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            extensionAccommodationServiceNo
          }
        }
      }
      personalDiscounts @include(if: $withPersonalDiscounts) {
        id
        ratioServiceNo
        name
        label
        info
        mandatorySettings @include(if: $withPersonalDiscountsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withPersonalDiscountsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
        }
      }
      importDateTime
      importStatus
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_MUTATION = `
  mutation Mutation($input: UpdateRatioTravelInput, $withRatioCatalogBundle: Boolean = false, $withDates: Boolean = false, $withDatesAvailabilityStatus: Boolean = false, $withDatesAvailabilityStatusTenantSettings: Boolean = false, $withDatesExtensionBaseDate: Boolean = false, $withDatesExtensionBaseDateAvailabilityStatus: Boolean = false, $withDatesExtensionBaseDateExtensionBaseDate: Boolean = false, $withDatesExtensionBaseDateExtension: Boolean = false, $withDatesExtensionBaseDatePackageSettings: Boolean = false, $withDatesExtensionBaseDateExtensions: Boolean = false, $withDatesExtension: Boolean = false, $withDatesExtensionTravelExtension: Boolean = false, $withDatesExtensionAccommodationMapItems: Boolean = false, $withDatesPackageSettings: Boolean = false, $withDatesExtensions: Boolean = false, $withDatesExtensionsTravelExtension: Boolean = false, $withDatesExtensionsAccommodationMapItems: Boolean = false, $withAccommodations: Boolean = false, $withAccommodationsCapacitySettings: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationsAddons: Boolean = false, $withAccommodationsAddonsCalculationSettings: Boolean = false, $withAccommodationsAddonsMandatorySettings: Boolean = false, $withExtensionAccommodations: Boolean = false, $withFamilyPackages: Boolean = false, $withFamilyPackagesAccommodation: Boolean = false, $withFamilyPackagesAccommodationCapacitySettings: Boolean = false, $withFamilyPackagesAccommodationAddons: Boolean = false, $withFamilyPackagesCapacitySettings: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackagesAddons: Boolean = false, $withFamilyPackagesAddonsCalculationSettings: Boolean = false, $withFamilyPackagesAddonsMandatorySettings: Boolean = false, $withPersonalAddons: Boolean = false, $withPersonalAddonsAllowedAgeGroups: Boolean = false, $withPersonalAddonsCalculationSettings: Boolean = false, $withPersonalAddonsMandatorySettings: Boolean = false, $withPersonalAddonsMandatorySettingsRules: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withBookingAddons: Boolean = false, $withBookingAddonsCalculationSettings: Boolean = false, $withBookingAddonsMandatorySettings: Boolean = false, $withBookingAddonsMandatorySettingsRules: Boolean = false, $withCollectiveAddons: Boolean = false, $withCollectiveAddonsAgeGroupServices: Boolean = false, $withCollectiveAddonsAgeGroupServicesAgeGroup: Boolean = false, $withCollectiveAddonsCalculationSettings: Boolean = false, $withCollectiveAddonsMandatorySettings: Boolean = false, $withCollectiveAddonsMandatorySettingsRules: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPersonalDiscounts: Boolean = false, $withPersonalDiscountsMandatorySettings: Boolean = false, $withPersonalDiscountsMandatorySettingsRules: Boolean = false) {
    travel: updateRatioTravel(input: $input) {
      id
      ratioCatalogBundle @include(if: $withRatioCatalogBundle) {
        id
        catalogCode
        travelCode
        json
      }
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      dates @include(if: $withDates) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withDatesAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withDatesAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        includesExtension
        extensionBaseDate @include(if: $withDatesExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          availabilityStatus @include(if: $withDatesExtensionBaseDateAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          includesExtension
          extensionBaseDate @include(if: $withDatesExtensionBaseDateExtensionBaseDate) {
            id
            dateNo
            startDate
            endDate
            includesExtension
            json
          }
          extension @include(if: $withDatesExtensionBaseDateExtension) {
            id
            label
            info
          }
          packageSettings @include(if: $withDatesExtensionBaseDatePackageSettings) {
            id
            ratioPackageNo
            price
            availabilityStatus
          }
          json
          extensions @include(if: $withDatesExtensionBaseDateExtensions) {
            id
            label
            info
          }
        }
        extension @include(if: $withDatesExtension) {
          id
          label
          info
          travelExtension @include(if: $withDatesExtensionTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withDatesExtensionAccommodationMapItems) {
            id
          }
        }
        packageSettings @include(if: $withDatesPackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withDatesExtensions) {
          id
          label
          info
          travelExtension @include(if: $withDatesExtensionsTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withDatesExtensionsAccommodationMapItems) {
            id
          }
        }
      }
      accommodations @include(if: $withAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withAccommodationsCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withAccommodationsAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withAccommodationsAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withAccommodationsAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
      }
      extensionAccommodations @include(if: $withExtensionAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        extensionAccommodationServiceNo
      }
      familyPackages @include(if: $withFamilyPackages) {
        id
        ratioServiceNo
        accommodation @include(if: $withFamilyPackagesAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withFamilyPackagesAccommodationCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withFamilyPackagesAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        name
        label
        info
        capacitySettings @include(if: $withFamilyPackagesCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withFamilyPackagesAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withFamilyPackagesAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withFamilyPackagesAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
      }
      personalAddons @include(if: $withPersonalAddons) {
        id
        ratioServiceNo
        name
        label
        info
        allowedAgeGroups @include(if: $withPersonalAddonsAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        calculationSettings @include(if: $withPersonalAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPersonalAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withPersonalAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
        }
      }
      accommodationAddons @include(if: $withAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
        }
      }
      bookingAddons @include(if: $withBookingAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withBookingAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withBookingAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withBookingAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
        }
      }
      collectiveAddons @include(if: $withCollectiveAddons) {
        id
        label
        info
        ageGroupServices @include(if: $withCollectiveAddonsAgeGroupServices) {
          id
          ageGroup @include(if: $withCollectiveAddonsAgeGroupServicesAgeGroup) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          ratioServiceNo
        }
        calculationSettings @include(if: $withCollectiveAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withCollectiveAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withCollectiveAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
        }
      }
      extensions @include(if: $withExtensions) {
        id
        label
        info
        travelExtension @include(if: $withExtensionsTravelExtension) {
          id
          duration
          name
          description
          highlights @include(if: $withExtensionsTravelExtensionHighlights) {
            id
            text
          }
          image @include(if: $withExtensionsTravelExtensionImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {
          id
          baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            extensionAccommodationServiceNo
          }
        }
      }
      personalDiscounts @include(if: $withPersonalDiscounts) {
        id
        ratioServiceNo
        name
        label
        info
        mandatorySettings @include(if: $withPersonalDiscountsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withPersonalDiscountsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
        }
      }
      importDateTime
      importStatus
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_MUTATION = `
  mutation Mutation($input: DeleteRatioTravelInput) {
    deleteRatioTravel(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TRAVEL_MUTATION = `
  mutation Mutation($input: DeleteRatioTravelInput) {
    forceDeleteRatioTravel(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_DATES_MUTATION = `
  mutation Mutation($input: addRatioTravelDatesInput) {
    addRatioTravelDates(input: $input) {
      id
      dateIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_DATES_MUTATION = `
  mutation Mutation($input: removeRatioTravelDatesInput) {
    removeRatioTravelDates(input: $input) {
      id
      dateIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_DATES_MUTATION = `
  mutation Mutation($input: createRatioTravelDatesInput) {
    createRatioTravelDates(input: $input) {
      id
      dateIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_DATES_MUTATION = `
  mutation Mutation($input: deleteRatioTravelDatesInput) {
    deleteRatioTravelDates(input: $input) {
      id
      dateIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_DATES_ORDER_MUTATION = `
  mutation Mutation($input: updateRatioTravelDatesOrderInput) {
    updateRatioTravelDatesOrder(input: $input) {
      id
      dateIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_ACCOMMODATIONS_MUTATION = `
  mutation Mutation($input: addRatioTravelAccommodationsInput) {
    addRatioTravelAccommodations(input: $input) {
      id
      accommodationIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_ACCOMMODATIONS_MUTATION = `
  mutation Mutation($input: removeRatioTravelAccommodationsInput) {
    removeRatioTravelAccommodations(input: $input) {
      id
      accommodationIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_ACCOMMODATIONS_MUTATION = `
  mutation Mutation($input: createRatioTravelAccommodationsInput) {
    createRatioTravelAccommodations(input: $input) {
      id
      accommodationIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_ACCOMMODATIONS_MUTATION = `
  mutation Mutation($input: deleteRatioTravelAccommodationsInput) {
    deleteRatioTravelAccommodations(input: $input) {
      id
      accommodationIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_ACCOMMODATIONS_ORDER_MUTATION = `
  mutation Mutation($input: updateRatioTravelAccommodationsOrderInput) {
    updateRatioTravelAccommodationsOrder(input: $input) {
      id
      accommodationIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_EXTENSION_ACCOMMODATIONS_MUTATION = `
  mutation Mutation($input: addRatioTravelExtensionAccommodationsInput) {
    addRatioTravelExtensionAccommodations(input: $input) {
      id
      extensionAccommodationIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_EXTENSION_ACCOMMODATIONS_MUTATION = `
  mutation Mutation($input: removeRatioTravelExtensionAccommodationsInput) {
    removeRatioTravelExtensionAccommodations(input: $input) {
      id
      extensionAccommodationIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_EXTENSION_ACCOMMODATIONS_MUTATION = `
  mutation Mutation($input: createRatioTravelExtensionAccommodationsInput) {
    createRatioTravelExtensionAccommodations(input: $input) {
      id
      extensionAccommodationIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_EXTENSION_ACCOMMODATIONS_MUTATION = `
  mutation Mutation($input: deleteRatioTravelExtensionAccommodationsInput) {
    deleteRatioTravelExtensionAccommodations(input: $input) {
      id
      extensionAccommodationIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_EXTENSION_ACCOMMODATIONS_ORDER_MUTATION = `
  mutation Mutation($input: updateRatioTravelExtensionAccommodationsOrderInput) {
    updateRatioTravelExtensionAccommodationsOrder(input: $input) {
      id
      extensionAccommodationIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_FAMILY_PACKAGES_MUTATION = `
  mutation Mutation($input: addRatioTravelFamilyPackagesInput) {
    addRatioTravelFamilyPackages(input: $input) {
      id
      familyPackageIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_FAMILY_PACKAGES_MUTATION = `
  mutation Mutation($input: removeRatioTravelFamilyPackagesInput) {
    removeRatioTravelFamilyPackages(input: $input) {
      id
      familyPackageIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_FAMILY_PACKAGES_MUTATION = `
  mutation Mutation($input: createRatioTravelFamilyPackagesInput) {
    createRatioTravelFamilyPackages(input: $input) {
      id
      familyPackageIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_FAMILY_PACKAGES_MUTATION = `
  mutation Mutation($input: deleteRatioTravelFamilyPackagesInput) {
    deleteRatioTravelFamilyPackages(input: $input) {
      id
      familyPackageIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_FAMILY_PACKAGES_ORDER_MUTATION = `
  mutation Mutation($input: updateRatioTravelFamilyPackagesOrderInput) {
    updateRatioTravelFamilyPackagesOrder(input: $input) {
      id
      familyPackageIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_PERSONAL_ADDONS_MUTATION = `
  mutation Mutation($input: addRatioTravelPersonalAddonsInput) {
    addRatioTravelPersonalAddons(input: $input) {
      id
      personalAddonIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_PERSONAL_ADDONS_MUTATION = `
  mutation Mutation($input: removeRatioTravelPersonalAddonsInput) {
    removeRatioTravelPersonalAddons(input: $input) {
      id
      personalAddonIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_PERSONAL_ADDONS_MUTATION = `
  mutation Mutation($input: createRatioTravelPersonalAddonsInput) {
    createRatioTravelPersonalAddons(input: $input) {
      id
      personalAddonIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_PERSONAL_ADDONS_MUTATION = `
  mutation Mutation($input: deleteRatioTravelPersonalAddonsInput) {
    deleteRatioTravelPersonalAddons(input: $input) {
      id
      personalAddonIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_PERSONAL_ADDONS_ORDER_MUTATION = `
  mutation Mutation($input: updateRatioTravelPersonalAddonsOrderInput) {
    updateRatioTravelPersonalAddonsOrder(input: $input) {
      id
      personalAddonIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_ACCOMMODATION_ADDONS_MUTATION = `
  mutation Mutation($input: addRatioTravelAccommodationAddonsInput) {
    addRatioTravelAccommodationAddons(input: $input) {
      id
      accommodationAddonIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_ACCOMMODATION_ADDONS_MUTATION = `
  mutation Mutation($input: removeRatioTravelAccommodationAddonsInput) {
    removeRatioTravelAccommodationAddons(input: $input) {
      id
      accommodationAddonIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_ACCOMMODATION_ADDONS_MUTATION = `
  mutation Mutation($input: createRatioTravelAccommodationAddonsInput) {
    createRatioTravelAccommodationAddons(input: $input) {
      id
      accommodationAddonIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_ACCOMMODATION_ADDONS_MUTATION = `
  mutation Mutation($input: deleteRatioTravelAccommodationAddonsInput) {
    deleteRatioTravelAccommodationAddons(input: $input) {
      id
      accommodationAddonIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_ACCOMMODATION_ADDONS_ORDER_MUTATION = `
  mutation Mutation($input: updateRatioTravelAccommodationAddonsOrderInput) {
    updateRatioTravelAccommodationAddonsOrder(input: $input) {
      id
      accommodationAddonIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_BOOKING_ADDONS_MUTATION = `
  mutation Mutation($input: addRatioTravelBookingAddonsInput) {
    addRatioTravelBookingAddons(input: $input) {
      id
      bookingAddonIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_BOOKING_ADDONS_MUTATION = `
  mutation Mutation($input: removeRatioTravelBookingAddonsInput) {
    removeRatioTravelBookingAddons(input: $input) {
      id
      bookingAddonIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_BOOKING_ADDONS_MUTATION = `
  mutation Mutation($input: createRatioTravelBookingAddonsInput) {
    createRatioTravelBookingAddons(input: $input) {
      id
      bookingAddonIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_BOOKING_ADDONS_MUTATION = `
  mutation Mutation($input: deleteRatioTravelBookingAddonsInput) {
    deleteRatioTravelBookingAddons(input: $input) {
      id
      bookingAddonIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_BOOKING_ADDONS_ORDER_MUTATION = `
  mutation Mutation($input: updateRatioTravelBookingAddonsOrderInput) {
    updateRatioTravelBookingAddonsOrder(input: $input) {
      id
      bookingAddonIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_COLLECTIVE_ADDONS_MUTATION = `
  mutation Mutation($input: addRatioTravelCollectiveAddonsInput) {
    addRatioTravelCollectiveAddons(input: $input) {
      id
      collectiveAddonIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_COLLECTIVE_ADDONS_MUTATION = `
  mutation Mutation($input: removeRatioTravelCollectiveAddonsInput) {
    removeRatioTravelCollectiveAddons(input: $input) {
      id
      collectiveAddonIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_COLLECTIVE_ADDONS_MUTATION = `
  mutation Mutation($input: createRatioTravelCollectiveAddonsInput) {
    createRatioTravelCollectiveAddons(input: $input) {
      id
      collectiveAddonIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_COLLECTIVE_ADDONS_MUTATION = `
  mutation Mutation($input: deleteRatioTravelCollectiveAddonsInput) {
    deleteRatioTravelCollectiveAddons(input: $input) {
      id
      collectiveAddonIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_COLLECTIVE_ADDONS_ORDER_MUTATION = `
  mutation Mutation($input: updateRatioTravelCollectiveAddonsOrderInput) {
    updateRatioTravelCollectiveAddonsOrder(input: $input) {
      id
      collectiveAddonIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_EXTENSIONS_MUTATION = `
  mutation Mutation($input: addRatioTravelExtensionsInput) {
    addRatioTravelExtensions(input: $input) {
      id
      extensionIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_EXTENSIONS_MUTATION = `
  mutation Mutation($input: removeRatioTravelExtensionsInput) {
    removeRatioTravelExtensions(input: $input) {
      id
      extensionIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_EXTENSIONS_MUTATION = `
  mutation Mutation($input: createRatioTravelExtensionsInput) {
    createRatioTravelExtensions(input: $input) {
      id
      extensionIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_EXTENSIONS_MUTATION = `
  mutation Mutation($input: deleteRatioTravelExtensionsInput) {
    deleteRatioTravelExtensions(input: $input) {
      id
      extensionIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_EXTENSIONS_ORDER_MUTATION = `
  mutation Mutation($input: updateRatioTravelExtensionsOrderInput) {
    updateRatioTravelExtensionsOrder(input: $input) {
      id
      extensionIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_PERSONAL_DISCOUNTS_MUTATION = `
  mutation Mutation($input: addRatioTravelPersonalDiscountsInput) {
    addRatioTravelPersonalDiscounts(input: $input) {
      id
      personalDiscountIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_PERSONAL_DISCOUNTS_MUTATION = `
  mutation Mutation($input: removeRatioTravelPersonalDiscountsInput) {
    removeRatioTravelPersonalDiscounts(input: $input) {
      id
      personalDiscountIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_PERSONAL_DISCOUNTS_MUTATION = `
  mutation Mutation($input: createRatioTravelPersonalDiscountsInput) {
    createRatioTravelPersonalDiscounts(input: $input) {
      id
      personalDiscountIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_PERSONAL_DISCOUNTS_MUTATION = `
  mutation Mutation($input: deleteRatioTravelPersonalDiscountsInput) {
    deleteRatioTravelPersonalDiscounts(input: $input) {
      id
      personalDiscountIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_PERSONAL_DISCOUNTS_ORDER_MUTATION = `
  mutation Mutation($input: updateRatioTravelPersonalDiscountsOrderInput) {
    updateRatioTravelPersonalDiscountsOrder(input: $input) {
      id
      personalDiscountIds
    }
  }`

// language=GraphQL
export const TRAVELS_DEPENDENTS_QUERY = `query Query($id: ID!, $withBookings: Boolean = false, $withTravelPricings: Boolean = false, $withCustomBookingFormFieldVisibilityConfigs: Boolean = false) {
  groupedDependents: ratioTravelDependents(id: $id) {
    bookings @include(if: $withBookings) {
      id
      referenceNo
      travellerRemarks
      travellerDataCorrectnessConfirmation
      localState
      backofficePayload
      backofficeResponse
      transmissionStatus
      webhookStatus
      webhookResponse
      webhookDuration
      confirmationEmailSent
      isPassportDataRequired
      passportDataReminderEmailSent
      passportDataReceived    }
    travelPricings @include(if: $withTravelPricings) {
      id
      isTravelDocumentationAvailable
    }
    customBookingFormFieldVisibilityConfigs @include(if: $withCustomBookingFormFieldVisibilityConfigs) {
      id
    }
  }
}`
